<template>
  <div class="container">
    <div class="top-box">
      <div class="flexrbc">
        <div class="flexr0c">
          <div class="title-label"></div>
          <div class="title">预付交易资金明细</div>
        </div>
        <div class="addOrg flexrcc" @click="exportExcel">
          <div class="btn">导出</div>
        </div>
      </div>
    </div>
    <div class="search-box">
      <div class="flexr0c filter">
        <div class="label">时间范围</div>
        <Row>
          <Col span="12">
            <DatePicker :value="value2" format="yyyy/MM/dd" type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 240px" @on-change="handleChange"></DatePicker>
          </Col>
        </Row>
        <div class="label">客户名称</div>
        <Select v-model="select1" style="width: 240px; margin-right: 20px">
          <Option v-for="item in optionList" :value="item.buyerName + '/' + item.buyerPhone + '/' + item.buyerId" :key="item.buyerId">{{ item.buyerName }}</Option>
        </Select>
        <RadioGroup v-model="disabledGroup">
          <Radio label="充值"></Radio>
          <Radio label="支出"></Radio>
          <Radio label="退税"></Radio>
        </RadioGroup>
        <div class="search-btn" @click="search">查询</div>
      </div>
    </div>
    <div class="content-box">
      <div class="content">
        <div class="title-box flexr0c">
          <div class="title">当前余额(元)</div>
          <div class="title">客户预付(元)</div>
          <div class="title">交易支付(元)</div>
        </div>
        <div class="item-box flexr0c">
          <div class="num">{{ overage.balance }}</div>
          <div class="num">{{ overage.sumInMoney }}</div>
          <div class="num">{{ overage.sumOutMoney }}</div>
        </div>
        <Table :loading="loading" border stripe :columns="tableHead" :data="tableData">
          <template class="flexr0c" slot-scope="{ row, index }" slot="action">
            <div class="flexr0c" v-if="row.state == 0">
              <div class="edit flexr0c" @click="action(index)">
                <div class="iconfont">&#xe604;</div>
                <div class="item">操作</div>
              </div>
            </div>
          </template>
        </Table>
        <div style="margin: 10px; overflow: hidden">
          <div style="float: right">
            <Page :total="total" :current="1" :pageSize="pageSize" @on-change="changePage" show-elevator show-total></Page>
          </div>
        </div>
      </div>
    </div>
    <div class="mask" v-if="modal2">
      <div v-if="modal2" class="pop1-box">
        <div class="top flexrcc">
          <div class="title">操作</div>
          <img @click="modal2 = false" src="../../assets/imgs/home/close.png" alt />
        </div>
        <div class="content">
          <div class="item flexc0s">
            <div class="title-box flexr0c">
              <span>*</span>
              <div class="title">客户名称</div>
            </div>
            <Select v-model="select1" style="width: 368px" filterable>
              <Option v-for="(item, index) in userList" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
            <div class="title-box flexr0c">
              <span>*</span>
              <div class="title">状态处理</div>
              <RadioGroup v-model="stateGroup">
                <Radio label="1">
                  <span class="radio">处理</span>
                </Radio>
                <Radio label="2">
                  <span class="radio">不处理</span>
                </Radio>
              </RadioGroup>
            </div>
          </div>
        </div>
        <div class="bottom flexrcc">
          <div class="cancel" @click="modal2 = false">取消</div>
          <div class="save" @click="save">保存</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'prePayment',
  data() {
    return {
      msg: '',
      select1: '全部//',
      // disabledGroup: "交易支付",
      disabledGroup: '',
      stateGroup: '',
      select1: '',
      buyerId: '',
      value2: [],
      optionList: [],
      userList: [],
      index: -1,
      total: 0,
      pageSize: 12,
      loading: true,
      modal2: false,
      overage: [],
      tableHead: [
        {
          title: '时间',
          key: 'createTime',
          width: 180,
          resizable: true
        },
        {
          title: '操作类型',
          key: 'actionType',
          width: 110,
          resizable: true
        },
        {
          title: '客户名称',
          key: 'buyerName',
          width: 220,
          resizable: true
        },
        {
          title: '资金变动',
          key: 'amount',
          width: 130,
          resizable: true
        },
        {
          title: '余额',
          key: 'currBalance',
          width: 140,
          resizable: true
        },
        {
          title: '备注',
          key: 'remark',
          width: 130,
          resizable: true
        },
        {
          title: '操作',
          slot: 'action',
          width: 110,
          resizable: true
        }
      ],
      tableData: []
    };
  },
  methods: {
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        'Y+': date.getFullYear().toString(), // 年
        'm+': (date.getMonth() + 1).toString(), // 月
        'd+': date.getDate().toString(), // 日
        'H+': date.getHours().toString(), // 时
        'M+': date.getMinutes().toString(), // 分
        'S+': date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0'));
        }
      }
      return fmt;
    },
    search() {
      this.getPage(1);
    },
    changePage(page) {
      this.getPage(page);
    },
    handleChange(daterange) {
      this.value2 = daterange;
    },
    action(index) {
      this.index = index;
      this.select1 = '';
      this.stateGroup = '';
      this.modal2 = true;
    },
    save() {
      var session = JSON.parse(localStorage['session']);
      var data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: '7aI2RUmnTeHZFyur4nS3YRJjB3YHsZZL',
        id: this.tableData[this.index].id,
        buyerId: this.select1,
        state: this.stateGroup
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.modal2 = false;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    getUserInfo() {
      var session = JSON.parse(localStorage['session']);
      var data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: '7e6OAiAvmLIjmLrJ5cpGKzjEhNJJhPWc'
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.userInfo = res.data;
          this.optionList = res.data;
          this.optionList.unshift({
            buyerName: '全部',
            buyerPhone: '',
            buyerId: ''
          });
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    tableLeft() {
      var session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: 'mthTkE21VWLw4OpHVHFSVNgTF0sZeJpL'
      };
      if (this.value2.length != 0) {
        data.startDate = this.value2[0].replace(/\//g, '-');
        data.endDate = this.value2[1].replace(/\//g, '-');
      }
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.overage = res.data;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    getUserList() {
      const session = JSON.parse(localStorage['session']);
      let data = {
        sessionId: session.sessionId,
        userId: session.userId,
        modeCode: '7e6OAiAvmLIjmLrJ5cpGKzjEhNJJhPWc'
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          res.data.forEach((item) => {
            let obj = {};
            obj.id = item.buyerId;
            obj.name = item.buyerName;
            this.userList.push(obj);
          });
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
        }
      });
    },
    getPage(index) {
      this.tableLeft();
      this.loading = true;
      var session = JSON.parse(localStorage['session']);
      var data = {
        sessionId: session.sessionId,
        userId: session.userId,
        enterpriseId: session.enterpriseId,
        modeCode: 'djC1X8ZxsJU5rvPRYVIPYdbF6PWDm1sn',
        pageIndex: index,
        pageSize: this.pageSize
      };
      if (this.disabledGroup != '') {
        switch (this.disabledGroup) {
          case '充值':
            data.fundType = 1;
            break;
          case '支出':
            data.fundType = 2;
            break;
          case '退税':
            data.fundType = 3;
            break;
          default:
            break;
        }
      }
      if (this.value2.length != 0) {
        data.startDate = this.value2[0].replace(/\//g, '-');
        data.endDate = this.value2[1].replace(/\//g, '-');
      }
      if (this.buyerId != '') {
        data.buyerId = this.select1.split('/')[2];
      }
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.total = res.count;
          res.result_ctn.forEach((item) => {
            item.fundType == 1 && item.infundType == 1 ? (item.actionType = '手工充值') : (item.actionType = '客户充值');
            item.fundType == 2 ? (item.actionType = '过站扣税') : item.actionType;
            item.fundType == 3 ? (item.actionType = '退税') : item.actionType;
            item.fundType == 4 ? (item.actionType = '提现') : item.actionType;
          });
          this.tableData = res.result_ctn;
          this.loading = false;
        } else {
          this.$Message['error']({
            background: true,
            content: res.msg
          });
          this.loading = false;
        }
      });
    },
    exportExcel(index) {
      var session = JSON.parse(localStorage['session']);
      var data = {
        sessionId: session.sessionId,
        userId: session.userId,
        enterpriseId: session.enterpriseId,
        modeCode: 'PKIBuOOFyVacGG6K5yc3JGGEuWEurLmY',
        fileName: '交易预付款明细', //导出文件名称
        suffix: 'xlsx'
      };
      if (this.disabledGroup != '') {
        switch (this.disabledGroup) {
          case '充值':
            data.fundType = 1;
            break;
          case '支出':
            data.fundType = 2;
            break;
          case '退税':
            data.fundType = 3;
            break;
          default:
            break;
        }
      }
      if (this.value2.length != 0) {
        data.startDate = this.value2[0].replace(/\//g, '-');
        data.endDate = this.value2[1].replace(/\//g, '-');
      }
      if (this.buyerName != '') {
        data.buyerName = this.buyerName;
      }
      this.$http.exportMethod(data).then((res) => {
        if (res.code == 1) {
          console.log('导出成功');
        }
      });
    }
  },
  created() {
    let date2 = this.dateFormat('YYYY-mm-dd', new Date());
    let date1 = this.dateFormat('YYYY-mm-', new Date()) + '01';
    this.value2.push(date2);
    this.value2.push(date2);
    this.getUserInfo();
    this.getUserList();
    this.getPage(1);
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 980px;
  text-align: center;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-left: 20px;
  background: #f2f3f5;
  position: relative;

  .top-box {
    background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
    border-radius: 10px 10px 0 0;
    width: 100%;
    height: 40px;

    & > div {
      height: 100%;
      width: 928px;
      margin: 0 auto;
    }

    .title-label {
      width: 4px;
      height: 14px;
      background: #2c59c3;
    }

    .title {
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #2c59c3;
      letter-spacing: 0.4px;
      margin-left: 6px;
    }

    .addOrg {
      background-image: linear-gradient(180deg, #b4ec51 0%, #429321 100%);
      border: 1px solid #4c9b25;
      border-radius: 6px;
      width: 110px;
      height: 30px;
      cursor: pointer;

      img {
        width: 14px;
        height: 14px;
        margin-right: 5px;
      }

      .btn {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0.35px;
      }
    }
  }

  .search-box {
    // overflow: hidden;

    /deep/.ivu-select-placeholder {
      text-align: start;
    }

    .filter {
      margin-top: 18px;
      margin-bottom: 14px;

      .label {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #616c84;
        margin: 0 10px 0 26px;
      }

      /deep/.ivu-date-picker-focused input,
      /deep/.ivu-date-picker-focused input {
        font-size: 14px;
      }

      /deep/.ivu-select-selected-value,
      /deep/.ivu-select-item {
        text-align: start;
      }

      /deep/.ivu-input-with-suffix {
        cursor: pointer;
      }

      /deep/.ivu-select-selection {
        height: 38px;
        background: #ffffff;
        // border: 1px solid #DFDFDF;
        box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
        border-radius: 8px;
      }

      /deep/.ivu-select-placeholder,
      /deep/.ivu-select-selected-value {
        height: 38px;
        line-height: 38px;
        padding-left: 24px;
        text-align: start;
      }

      /deep/.ivu-input-suffix {
        line-height: 38px;
      }

      /deep/.ivu-input-with-suffix {
        height: 38px;
        line-height: 38px;
        padding-left: 24px;
        background: #ffffff;
        // border: 1px solid #DFDFDF;
        box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
        border-radius: 8px;
      }

      .search-btn {
        background-image: linear-gradient(180deg, #91caff 0%, #0074d6 97%);
        border: 1px solid #006bc4;
        border-radius: 6px;
        width: 80px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0.35px;
        cursor: pointer;

        &:hover {
          background-image: linear-gradient(180deg, #cce7ff 0%, #027de6 97%);
        }
      }
    }
  }

  .content-box {
    width: 980px;
    min-height: 534px;
    background: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    overflow: hidden;

    .content {
      width: 928px;
      margin-top: 30px;

      .title-box {
        width: 928px;
        height: 40px;
        background-color: rgba(224, 229, 240, 0.3);

        .title {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #8b93a7;
          flex: 1;
        }
      }

      .item-box {
        width: 928px;
        height: 80px;

        .num {
          font-family: Impact;
          font-size: 24px;
          flex: 1;
          margin: 25px 0;
          color: #2c59c3;
        }
      }

      .edit {
        cursor: pointer;

        .item {
          margin-left: 4px;
        }
      }

      /deep/ .ivu-table th {
        background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
        color: #fff;
      }

      /deep/ .ivu-table th:last-child {
        border-top-right-radius: 10px;
        background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
        color: #fff;
      }

      /deep/ .ivu-table th:first-child {
        // border-top-left-radius: 10px;
        background-image: linear-gradient(180deg, #2f66ba 0%, #153684 100%);
        color: #fff;
      }
    }
  }

  .mask {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;

    .pop1-box {
      position: absolute;
      width: 480px;
      height: 560px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;

      .top {
        width: 100%;
        height: 46px;
        background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
        border-radius: 10px 10px 0 0;

        .title {
          font-family: PingFangSC-Semibold;
          font-size: 18px;
          color: #ffffff;
          letter-spacing: 0.34px;
        }

        img {
          position: absolute;
          float: right;
          width: 16px;
          height: 16px;
          right: 15px;
          cursor: pointer;
        }
      }

      .content {
        width: 100%;
        height: 200px;
        background: #fff;
        // overflow: hidden;

        .item {
          width: 368px;
          height: 405px;
          //   margin-top: 8px;
          margin-left: 56px;

          .name-input,
          /deep/.ivu-input {
            width: 368px;
            height: 48px;
            // background: #f5f7fa;
            border-radius: 8px;
            padding-left: 24px;
          }

          /deep/ .ivu-select-selection {
            width: 368px;
            height: 48px;
            line-height: 48px;
            border-radius: 8px;
            padding-left: 24px;
            background: #ffffff;
            // border: 1px solid #DFDFDF;
            box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
            text-align: start;
          }

          /deep/ .ivu-select-placeholder,
          /deep/.ivu-select-selected-value {
            line-height: 48px;
            padding-left: 0;
            text-align: start;
          }

          .price-input {
            background: #ffffff;
            // border: 1px solid #dfdfdf;
            box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
            border-radius: 8px;
            width: 316px;
            height: 48px;
            // padding-left: 24px;
          }

          .unit {
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #4a4a4a;
            letter-spacing: 0.3px;
            width: 42px;
            margin-left: 12px;
          }

          .title-box {
            margin: 20px 0 8px 0;

            span {
              color: #d0021b;
              margin-right: 5px;
            }

            span.radio {
              color: inherit;
            }

            /deep/ .ivu-radio-wrapper {
              font-family: PingFangSC-Regular;
              font-size: 16px;
              color: #4a4a4a;
              letter-spacing: 0.3px;
            }

            /deep/.ivu-radio {
              margin-left: 30px;
            }

            .title {
              font-family: PingFangSC-Semibold;
              font-size: 16px;
              color: #9097a9;
              letter-spacing: 0.3px;
              line-height: 22px;
            }
          }

          .remark,
          /deep/textarea.ivu-input {
            background: #ffffff;
            // border: 1px solid #dfdfdf;
            box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
            border-radius: 8px;
            width: 368px;
            height: 140px;
            padding: 14px;
            resize: none;
          }

          .remark {
            padding: 0;
          }
        }
      }

      .bottom {
        // transform: scaleY(-1);
        background: #f5f5f5;
        border-radius: 0 0 10px 10px;
        height: 50px;

        .cancel {
          width: 138px;
          height: 30px;
          line-height: 30px;
          background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.97) 0%, rgba(251, 251, 251, 0.98) 37%, #f5f5f5 100%);
          border: 1px solid #cacaca;
          border-radius: 4px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #000000;
          letter-spacing: 0;
          cursor: pointer;

          &:hover {
            background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.97) 0%, rgba(251, 251, 251, 0.98) 37%, #e9e9e9 100%);
          }
        }

        .save {
          width: 138px;
          height: 30px;
          line-height: 30px;
          background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
          border: 1px solid #285ed3;
          border-radius: 4px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0;
          margin-left: 16px;
          cursor: pointer;

          &:hover {
            background-image: linear-gradient(180deg, #5295f5 0%, #2559d1 99%);
          }
        }
      }
    }
  }

  /deep/.ivu-table-wrapper-with-border {
    border-radius: 12px;
  }

  /deep/.ivu-select-selected-value,
  /deep/.ivu-select-item {
    text-align: start;
    border-bottom: 1px solid #fafafa;
  }

  /deep/span.ivu-select-selected-value {
    border-bottom: none;
  }

  /deep/.ivu-select-item:last-child {
    border-bottom: none;
  }

  /deep/.ivu-radio-inner:after {
    background-color: #2c59c3;
  }

  /deep/.ivu-radio-checked .ivu-radio-inner {
    border-color: #2c59c3;
  }

  /deep/.ivu-table-stripe .ivu-table-body tr:nth-child(2n) td,
  .ivu-table-stripe .ivu-table-fixed-body tr:nth-child(2n) td {
    background-color: rgba(236, 241, 247, 0.4);
  }

  /deep/.ivu-table-stripe .ivu-table-body tr.ivu-table-row-hover td,
  .ivu-table-stripe .ivu-table-fixed-body tr.ivu-table-row-hover td {
    background: rgba(255, 255, 235, 0.15) !important;
  }

  /deep/.ivu-table-row-hover {
    background: rgba(255, 255, 235, 0.15) !important;
  }

  /deep/.ivu-input-with-suffix {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.07);
  }

  /deep/.ivu-table-wrapper-with-border {
    border-radius: 12px;
    border: 1px solid #dcdee2;
    border-right: none;
  }

  /deep/.ivu-table td,
  .ivu-table th {
    border-bottom: none;
  }

  /deep/.ivu-table:before {
    display: none;
  }
}
</style>
